const rows = [
  { feature: "Appointment Required", agency: "Yes — appointments scarce, often 2–4 week wait", fpc: "No appointment needed — we handle submission" },
  { feature: "Travel Distance", agency: "3+ hours to Salt Lake City — full-day trip", fpc: "Ship overnight from Jackson — no travel needed" },
  { feature: "Processing Speed", agency: "Same-day or next-day if you get an appointment", fpc: "2–9 business days with reserved courier slots" },
  { feature: "Document Review", agency: "You submit — errors cause same-day rejection", fpc: "Agent reviews everything before submission" },
  { feature: "Status Updates", agency: "No phone or email updates — mail only", fpc: "Daily updates by phone or email" },
  { feature: "Eligibility", agency: "Life-or-death emergencies or travel within 14 days only", fpc: "Available to all travelers regardless of timeline" },
  { feature: "Money-Back Guarantee", agency: "None — fees nonrefundable", fpc: "Included — no additional cost" },
  { feature: "Government Shutdowns", agency: "Fully suspended during shutdowns", fpc: "Not affected — continues processing" },
  { feature: "Cost", agency: "Government fee + full-day travel costs", fpc: "Service fee + government fee — no travel needed" },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Emergency Passports</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Salt Lake City Regional Agency vs. Fast Passport Center
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            If you need your passport <strong className="text-[#1A365D]">within two weeks</strong>, the Denver Regional Passport Agency is your only DIY option — 450+ miles from Jackson. Fast Passport Center gives you a faster, simpler path without the mountain drive.
          </p>
        </div>

        <div className="mb-8 bg-amber-50 border border-[#F6C344]/40 rounded-lg p-6">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">
            Jackson Passport Agency Appointment Not Available?
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Regional passport agency appointments are routinely booked 2–4 weeks out — and walk-ins are never accepted. If you searched for an appointment and came up empty, Fast Passport Center&apos;s registered courier channel is your fastest next step. No appointment. No waiting in line at the federal building. Processing as fast as 2–3 business days.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="rounded-lg overflow-hidden border border-gray-200">
          <div className="grid grid-cols-3 bg-[#1A365D] text-white">
            <div className="p-4 text-sm font-semibold text-white/50">Feature</div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10">
              <i className="ri-government-line mr-1.5"></i>Salt Lake City Agency
            </div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10 bg-[#F6C344]/15">
              <i className="ri-shield-check-line mr-1.5 text-[#F6C344]"></i>Fast Passport Center
            </div>
          </div>
          {rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-3 border-t border-gray-100 ${i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}`}>
              <div className="p-4 text-sm font-semibold text-[#1A365D]">{row.feature}</div>
              <div className="p-4 text-sm text-gray-500 border-l border-gray-100 flex items-start gap-2">
                <i className="ri-close-circle-line text-red-400 flex-shrink-0 mt-0.5"></i>
                <span>{row.agency}</span>
              </div>
              <div className="p-4 text-sm text-gray-700 border-l border-gray-100 flex items-start gap-2 bg-[#F6C344]/5">
                <i className="ri-checkbox-circle-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                <span className="font-medium">{row.fpc}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-gray-400 text-xs mt-3">
            Denver Regional Passport Agency — 3151 S Vaughn Way, Suite 600, Aurora, CO 80014 — 450+ miles southeast of Jackson via US-26/I-25
          </p>
        </div>
      </div>
    </section>
  );
}